import type { ReactNode } from 'react';
import { cx } from '../lib/cx';

export interface SideNavItem {
  value: string;
  label: ReactNode;
  icon?: ReactNode;
  /** Trailing count / status dot. */
  meta?: ReactNode;
}

export interface SideNavProps {
  items: SideNavItem[];
  value: string;
  onChange: (value: string) => void;
  /** Accessible name, e.g. "Settings sections". */
  'aria-label': string;
  className?: string;
}

/** Vertical section nav that becomes a horizontal scroller on narrow screens —
 *  the Settings page's left rail (brief §7.9). */
export function SideNav({ items, value, onChange, className, ...rest }: SideNavProps) {
  return (
    <nav className={cx('tc-sidenav', className)} aria-label={rest['aria-label']}>
      {items.map((item) => (
        <button
          key={item.value}
          type="button"
          className="tc-sidenav__item"
          aria-current={item.value === value ? 'true' : undefined}
          onClick={() => onChange(item.value)}
        >
          {item.icon && <span className="tc-sidenav__icon">{item.icon}</span>}
          <span className="tc-sidenav__label">{item.label}</span>
          {item.meta && <span className="tc-sidenav__meta">{item.meta}</span>}
        </button>
      ))}
    </nav>
  );
}
